var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"tw-rounded-full tw-flex tw-items-center tw-justify-center tw-w-10 tw-h-10",class:_vm.classes.background},[_c('SvgIcon',{staticClass:"tw-w-5 tw-h-5",class:_vm.classes.content,attrs:{"name":_vm.name}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }